(function () {
  const DEBOUNCE_MS = 80;
  let debounceTimer = null;
  let hideQtyDebounce = null;

  function getConfig() {
    return window.themeBundleCartRemove;
  }

  const HIDDEN_CART_PROPERTY_MARKERS = ['_bundle_community_access_trigger', '_bundle_community_access_auto'];
  const BUNDLE_AUTO_ADDON_PROPERTY = '_bundle_community_access_auto';

  function isBundleAutoAddonLine(item) {
    const props = item.properties || {};
    return props[BUNDLE_AUTO_ADDON_PROPERTY] === 'true';
  }

  function bundleAutoAddonItemPayload(cfg) {
    return {
      id: Number(cfg.addonVariantId),
      quantity: 1,
      selling_plan: Number(cfg.addonSellingPlanId),
      properties: { [BUNDLE_AUTO_ADDON_PROPERTY]: 'true' },
    };
  }

  function getTriggerProductIds(cfg) {
    if (!cfg) return [];
    const ids = [];
    if (cfg.triggerProductId) ids.push(Number(cfg.triggerProductId));
    if (Array.isArray(cfg.triggerProductIds)) {
      cfg.triggerProductIds.forEach((id) => ids.push(Number(id)));
    }
    if (Array.isArray(cfg.triggerProductIdsInCart)) {
      cfg.triggerProductIdsInCart.forEach((id) => ids.push(Number(id)));
    }
    return [...new Set(ids.filter((id) => !Number.isNaN(id) && id > 0))];
  }

  function isBundleTriggerLine(item, cfg) {
    const triggerIds = getTriggerProductIds(cfg);
    if (!triggerIds.length) return false;
    return triggerIds.includes(Number(item.product_id));
  }

  function hideInternalCartPropertiesInUpcart() {
    const roots = document.querySelectorAll('#CartPopup, #UpcartPopup, [id^="Upcart"]');
    roots.forEach((root) => {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.upcart-product-item, [class*="ProductRow"]').forEach((row) => {
        row.querySelectorAll('*').forEach((el) => {
          if (el.children.length > 0) return;
          const text = (el.textContent || '').trim();
          if (!text) return;
          const isInternal = HIDDEN_CART_PROPERTY_MARKERS.some((marker) => text.indexOf(marker) !== -1);
          if (!isInternal) return;
          const hideTarget =
            el.closest('.upcart-item-property') ||
            el.closest('[class*="item-property"]') ||
            el.closest('[class*="ItemProperty"]') ||
            el;
          hideTarget.style.display = 'none';
          hideTarget.setAttribute('hidden', '');
          hideTarget.setAttribute('aria-hidden', 'true');
        });
      });
    });
  }

  function matchesAddonItem(item, cfg) {
    if (Number(item.product_id) !== Number(cfg.addonProductId)) return false;
    if (!cfg.addonSellingPlanId) return true;
    const spid =
      item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.id
        : null;
    return Number(spid) === Number(cfg.addonSellingPlanId);
  }

  function cartJsonUrl() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js';
  }

  function fetchCartJson() {
    return fetch(cartJsonUrl()).then((r) => r.json());
  }

  const UPCART_CART_UPDATED_EVENT = 'aftersell-upcart:public-events:cart-updated';
  let lastUpcartCart = null;
  let syncRequestedAt = 0;
  let syncForceFetch = false;

  window.addEventListener(UPCART_CART_UPDATED_EVENT, (event) => {
    const items = event.detail && event.detail.cart && event.detail.cart.items;
    if (!Array.isArray(items)) return;
    lastUpcartCart = {
      at: Date.now(),
      items: items.map((item) => ({
        key: item.key,
        product_id: item.productId,
        variant_id: item.variantId,
        properties: item.properties || item.lineItemProperties || {},
        selling_plan_allocation:
          item.sellingPlanAllocation && item.sellingPlanAllocation.sellingPlan
            ? { selling_plan: { id: item.sellingPlanAllocation.sellingPlan.id } }
            : null,
      })),
    };
    scheduleBundleAddonSync(true);
  });

  function getCartItems(knownItems) {
    if (knownItems) return Promise.resolve(knownItems);
    return fetchCartJson().then((cart) => cart.items || []);
  }

  function getUpcartRoots() {
    return document.querySelectorAll('#CartPopup, #UpcartPopup, [id^="Upcart"]');
  }

  function findUpcartRowForVariant(variantId) {
    const needles = ['variant=' + variantId, 'variant%3D' + variantId];
    const rows = new Set();
    getUpcartRoots().forEach((root) => {
      if (!root || !root.querySelectorAll) return;
      needles.forEach((needle) => {
        root.querySelectorAll('a[href*="' + needle + '"]').forEach((a) => {
          const row =
            a.closest('.upcart-product-item') ||
            a.closest('[class*="ProductRow"]') ||
            a.closest('[class*="product-item"]');
          if (row) rows.add(row);
        });
      });
    });
    return rows;
  }

  function clearUpcartAddonRowClasses() {
    getUpcartRoots().forEach((root) => {
      if (!root || !root.querySelectorAll) return;
      root
        .querySelectorAll('.theme-bundle-addon-row--fixed-qty, .theme-bundle-addon-row--no-remove')
        .forEach((row) => {
          row.classList.remove('theme-bundle-addon-row--fixed-qty', 'theme-bundle-addon-row--no-remove');
        });
    });
  }

  function markUpcartRowsForVariant(variantId, locked) {
    if (!variantId) return;
    findUpcartRowForVariant(variantId).forEach((row) => {
      row.classList.add('theme-bundle-addon-row--fixed-qty');
      if (locked) row.classList.add('theme-bundle-addon-row--no-remove');
    });
  }

  function applyUpcartAddonUi(cfg, knownItems) {
    return getCartItems(knownItems)
      .then((items) => {
        const hasTrigger = items.some((i) => isBundleTriggerLine(i, cfg));
        const addonLine = items.find((line) => matchesAddonItem(line, cfg) && isBundleAutoAddonLine(line));
        const locked = hasTrigger && Boolean(addonLine);
        const variantId = addonLine && addonLine.variant_id ? String(addonLine.variant_id) : cfg.addonVariantId ? String(cfg.addonVariantId) : null;

        clearUpcartAddonRowClasses();
        if (variantId) markUpcartRowsForVariant(variantId, locked);
      })
      .catch(() => {});
  }

  function scheduleHideBundleAddonQty() {
    const cfg = getConfig();
    if (!cfg || !cfg.addonProductId) return;
    setupHideBundleAddonQtyObserver();
    clearTimeout(hideQtyDebounce);
    hideQtyDebounce = setTimeout(() => {
      hideInternalCartPropertiesInUpcart();
      applyUpcartAddonUi(cfg);
    }, 50);
  }

  function setupHideBundleAddonQtyObserver() {
    ['#CartPopup', '#UpcartPopup'].forEach((sel) => {
      const el = document.querySelector(sel);
      if (!el || el.dataset.themeBundleQtyObserved) return;
      el.dataset.themeBundleQtyObserved = '1';
      const obs = new MutationObserver(() => scheduleHideBundleAddonQty());
      obs.observe(el, { childList: true, subtree: true });
    });
  }

  let restoreAddonInFlight = false;

  function restoreAddonIfNeeded(cfg, items) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

    return Promise.resolve()
      .then(() => {
        const hasTrigger = items.some((i) => isBundleTriggerLine(i, cfg));
        const hasAnyAddon = items.some((i) => matchesAddonItem(i, cfg));
        if (!hasTrigger || hasAnyAddon || !cfg.addonVariantId || !cfg.addonSellingPlanId) return false;
        if (restoreAddonInFlight) return false;

        restoreAddonInFlight = true;
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({
            items: [bundleAutoAddonItemPayload(cfg)],
          }),
        })
          .then((r) => r.json())
          .then(() => true)
          .finally(() => {
            restoreAddonInFlight = false;
          });
      })
      .then((restored) => {
        if (restored && typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        }
        return restored;
      })
      .catch(() => false);
  }

  function scheduleBundleAddonSync(forceFetch) {
    const cfg = getConfig();
    if (!cfg || !cfg.addonProductId || !getTriggerProductIds(cfg).length) return;

    if (!debounceTimer) syncRequestedAt = Date.now();
    if (forceFetch === true) syncForceFetch = true;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      syncForceFetch = false;
      fetchCartJson()
        .then((cart) => cart.items || [])
        .then((items) =>
          restoreAddonIfNeeded(cfg, items).then((restored) => {
            const knownItems = restored ? null : items;
            removeAddonIfTriggerGone(cfg, knownItems);
            applyUpcartAddonUi(cfg, knownItems);
          })
        )
        .catch(() => {});
    }, DEBOUNCE_MS);
  }

  function scheduleBundleAddonSyncAfterRemoval() {
    scheduleBundleAddonSync(true);
  }

  function setupUpcartAddonRemoveBlock() {
    if (document.documentElement.dataset.themeBundleRemoveBlock) return;
    document.documentElement.dataset.themeBundleRemoveBlock = '1';

    document.addEventListener(
      'click',
      (event) => {
        const cfg = getConfig();
        if (!cfg || !cfg.addonProductId) return;

        const row = event.target.closest('.upcart-product-item, [class*="ProductRow"], [class*="product-item"]');
        if (!row || !row.classList.contains('theme-bundle-addon-row--no-remove')) return;

        const removeControl = event.target.closest(
          '[class*="Remove"], [class*="remove"], [class*="Trash"], [class*="trash"], button[aria-label*="Remove"], button[aria-label*="remove"]'
        );
        if (!removeControl) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true
    );
  }

  function removeAddonIfTriggerGone(cfg, knownItems) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

    const loadItems = knownItems ? Promise.resolve(knownItems) : fetchCartJson().then((cart) => cart.items || []);

    loadItems
      .then((items) => {
        if (items.some((i) => isBundleTriggerLine(i, cfg))) {
          return false;
        }

        const updates = {};
        for (const item of items) {
          if (matchesAddonItem(item, cfg) && isBundleAutoAddonLine(item) && item.key) {
            updates[item.key] = 0;
          }
        }

        if (!Object.keys(updates).length) {
          return false;
        }

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({ updates }),
        }).then((r) => r.json()).then(() => true);
      })
      .then((removedAny) => {
        if (removedAny && typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        }
      })
      .catch(() => {});
  }

  function hookUpcart() {
    const prevRemoved = window.upcartOnItemRemoved;
    window.upcartOnItemRemoved = function upcartOnItemRemovedWrapped() {
      if (typeof prevRemoved === 'function') prevRemoved.apply(this, arguments);
      scheduleBundleAddonSyncAfterRemoval();
      scheduleHideBundleAddonQty();
    };

    const prevUpdated = window.upcartOnCartUpdated;
    window.upcartOnCartUpdated = function upcartOnCartUpdatedWrapped() {
      if (typeof prevUpdated === 'function') prevUpdated.apply(this, arguments);
      scheduleBundleAddonSync();
      scheduleHideBundleAddonQty();
    };

    const prevLoaded = window.upcartOnCartLoaded;
    window.upcartOnCartLoaded = function upcartOnCartLoadedWrapped() {
      if (typeof prevLoaded === 'function') prevLoaded.apply(this, arguments);
      scheduleHideBundleAddonQty();
    };

    if (typeof window.upcartSubscribeItemRemoved === 'function') {
      try {
        window.upcartSubscribeItemRemoved(scheduleBundleAddonSyncAfterRemoval);
      } catch (_e) {}
    }

    setupUpcartAddonRemoveBlock();
    hideInternalCartPropertiesInUpcart();
    scheduleHideBundleAddonQty();
    setupHideBundleAddonQtyObserver();
    setTimeout(scheduleHideBundleAddonQty, 300);
    setTimeout(scheduleHideBundleAddonQty, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookUpcart);
  } else {
    hookUpcart();
  }

  let poll = 0;
  const pollIv = setInterval(() => {
    poll += 1;
    if (typeof window.upcartSubscribeItemRemoved === 'function') {
      try {
        window.upcartSubscribeItemRemoved(scheduleBundleAddonSyncAfterRemoval);
      } catch (_e) {}
      clearInterval(pollIv);
    } else if (poll > 50) {
      clearInterval(pollIv);
    }
  }, 150);
})();
